<template>
    <div class="highlighted-topics-container">
        <div class="highlighted-topics py-2">
            <div class="card topic-card" v-for="topic in highlightedTopics" :key="topic.name"
                @click="openURL(topic.path)">
                <div class="card-body" style="height: 100% !important">
                    <h5 class="card-title">{{ getOnlyTitle(topic.name) }}</h5>
                    <p class="card-text">{{ getContentBlurb(topic.content) }}</p>
                    <div class="card-bottom">
                        <span class="more-details float-end px-2 pb-1">More Details<i class="arrow right"></i></span>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import PageList from '@/PageList';

// Get HTML Content
async function loadPageContent(htmlFile) {
    if (!htmlFile) return "<!-- No HTML File for this page -->";
    return (await import(`@/pages/${htmlFile}`)).default;
}


export default {
    data() {
        return {
            highlightedTopics: []
        }
    },
    mounted() {
        this.highlightedTopics = PageList.filter(page => page.type === 'highlightedTopic');

        this.highlightedTopics.map(async (topic) => {
            if (topic.htmlContent !== undefined) {
                topic.content = await loadPageContent(topic.htmlContent)
            }
        })
    },

    methods: {
        getContentBlurb(content) {
            try {
                // Remove header tags
                let cleanText = content.replace(/<h\d[^>]*>.*?<\/h\d>/gi, '');

                // Remove elements with "alert" class
                cleanText = cleanText.replace(/<[^>]*?class=".*?alert.*?".*?>.*?<\/[^>]*?>/gi, '');

                // Remove HTML tags from content
                cleanText = cleanText.replace(/<\/?[^>]+(>|$)/g, "");

                // remove non-breaking spaces
                cleanText = cleanText.replace(/&nbsp;/g, ' ');

                // Trim the string to the maximum length
                let trimmedString = cleanText.substr(0, 250);

                //remove trailing spaces
                trimmedString = trimmedString.replace(/\s*$/, "");

                // Re-trim if we are in the middle of a word
                trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" "))) + "..."

                return trimmedString;
            } catch (error) {
                console.log(error);
                return;
            }
        },

        openURL(url) {
            window.open(url, '_self');
        },

        getOnlyTitle(text) {
            console.log(text)
            return text.replace("Highlighted Topic - ", '');

        }
    }
}
</script>

<style>
.highlighted-topics-container {
    width: 100%;
    overflow-x: auto;
}

.highlighted-topics {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 1rem;
    height: 225px
}

.topic-card {
    cursor: pointer;
    float: left;
    flex: 0 0 18rem;
    -webkit-filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.2));
    -moz-filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.2));
    -ms-filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.2));
    -o-filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.2));
    filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.2));
    height: 100% !important;
}

.card-text {
    overflow: hidden;
    max-height: 70%;
}

.card-bottom {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;

}

.more-details {
    font-weight: 600;
    margin-right: 5px;
}

.arrow {
    border: solid black;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;
    margin-left: 3px;
}

.right {
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
}

@media screen and (max-width: 768px) {
    .highlighted-topics {
        flex-direction: column;
        gap: 1rem;
        height: auto;
    }

    .topic-card {
        flex: 0 0 100%;
    }

}
</style>